import React, { useEffect, useState } from 'react'
import { Card, CardContent, Grid, Stack } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import i18n from 'simple-react-i18n'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import useTitle from 'utils/customHook/useTitle'
import useStateAppSetting from 'utils/customHook/useStateAppSetting'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import AdministrationAction from 'administration/actions/AdministrationAction'
import ProgressBar from 'components/progress/ProgressBar'
import useActions from 'utils/customHook/useActions'
import SimpleCheckbox from 'components/forms/SimpleCheckbox'
import { isTrue } from 'utils/SettingUtils'

const PlanificationSettingsApp = () => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [readMode, setReadMode] = useState(true)

    const {
        applicationSettings,
    } = useSelector(store => ({
        applicationSettings: store.AdministrationReducer.applicationSettings,
    }), shallowEqual)

    const [activateRegulationCoef, setActivateRegulationCoef, onCancelActivateRegulationCoef] = useStateAppSetting('activateRegulationCoef')

    const dispatch = useDispatch()

    useEffect(() => {
        if (!applicationSettings.length) {
            dispatch(AdministrationAction.fetchApplicationSettings()).then(setDataLoaded(true))
        } else {
            setDataLoaded(true)
        }
    }, [applicationSettings.length, dispatch])

    useTitle(() => ([{
        title: i18n.planning,
        href: 'planning/dashboard',
    }, {
        title: i18n.settings,
        href: 'planning/settings',
    }]), [])

    const onSave = () => {
        const settings = [
            { parameter: 'activateRegulationCoef', value: activateRegulationCoef },
        ]
        setDataLoaded(false)
        dispatch(AdministrationAction.updateSieauParameters(settings)).then(() => {
            dispatch(AdministrationAction.fetchApplicationSettings()).then(() => {
                setReadMode(true)
                setDataLoaded(true)
            })
        })
    }

    useActions(() => {
        return readMode ? {
            edit: () => setReadMode(false),
        } : {
            save: onSave,
            cancel: () => {
                onCancelActivateRegulationCoef()
                setReadMode(true)
            },
        }
    }, [readMode, activateRegulationCoef])

    if (!dataLoaded) {
        return <ProgressBar indeterminate />
    }

    return (
        <Stack padding={1}>
            <Card>
                <CardTitle title={i18n.parameters} />
                <CardContent>
                    <StyledFieldSet sx={{ margin: 0 }}>
                        <StyledLegend>{i18n.par}</StyledLegend>
                        <Grid container spacing={1}>
                            <SimpleCheckbox
                                label={i18n.activateRegulationCoef}
                                checked={isTrue(activateRegulationCoef)}
                                onToggle={() => setActivateRegulationCoef(prev => isTrue(prev) ? '0' : '1')}
                                disabled={readMode}
                            />
                        </Grid>
                    </StyledFieldSet>
                </CardContent>
            </Card>
        </Stack>
    )
}

export default PlanificationSettingsApp
